import AVENGER from "../../assets/img/AVENGER.png";
import AVENGER_E from "../../assets/img/AVENGER-E.png";
import COMPASS from "../../assets/img/COMPASS.png";
import GRAND_CHEROKEE from "../../assets/img/GRAN-CHEROKEE.png";
import RENEGADE from "../../assets/img/RENEGADE.png";

import AVENGER_4XE from "../../assets/img/AVENGER-4XE.png";
import NEW_COMPASS_E_HYBRID from "../../assets/img/NEW-COMPASS-E-HYBRID.png";
import NEW_COMPASS_E from "../../assets/img/NEW-COMPASS-E.png";

export const vehicleImages: Record<string, string> = {
  Avenger: AVENGER,
  "Avenger 4xe": AVENGER_4XE,
  "Avenger Električni": AVENGER_E,
  "Novi Compass e-Hybrid": NEW_COMPASS_E_HYBRID,
  "Novi Compass Električni": NEW_COMPASS_E,
  Compass: COMPASS,
  "Grand Cherokee": GRAND_CHEROKEE,
  Renegade: RENEGADE,
};

export const imagesOrderOffer = [
  "Avenger",
  "Avenger 4xe",
  "Avenger Električni",
  "Novi Compass e-Hybrid",
  "Novi Compass Električni",
  // "Compass",
  // "Grand Cherokee",
  // "Renegade",
];

export const imagesOrderTestDrive = [
  "Avenger",
  // "Compass",
  // "Grand Cherokee",
  // "Renegade",
];
